export function toDisplayDate(value: Date | string): string {
  return new Date(value).toLocaleDateString('fr-BE');
}
